import React, { createContext, Dispatch, useContext, useReducer, useMemo } from "react";
import { ConfigurationState, ConfigurationStateActionType } from "./interfaces";
import initialConfigurationState from "./initialConfigurationState";
import ConfigurationStateReducer from "./configurationStateReducer"

export const ConfigurationStateContext = React.createContext<{
    configurationState: ConfigurationState
    dispatch: Dispatch<ConfigurationStateActionType>
  }>({ configurationState: initialConfigurationState, dispatch: () => initialConfigurationState })

const { Provider } = ConfigurationStateContext

interface ConfigurationStateProviderProps {
    children: React.ReactNode
}

export type ConfigurationStateReducerType = (
  state: ConfigurationState,
  action: ConfigurationStateActionType
) => ConfigurationState

const ConfigurationStateProvider: React.FC<ConfigurationStateProviderProps> = ({
  children,
}) => {
  const [configurationState, dispatch] = useReducer<ConfigurationStateReducerType>(
    ConfigurationStateReducer,
    initialConfigurationState
  )

  const contextValue = useMemo(() => ({ configurationState, dispatch }), [
    configurationState,
    dispatch,
  ])

  return <Provider value={contextValue}>{children}</Provider>
}

export default ConfigurationStateProvider





